<template>
  <div id="app" style="width: 100%;position: relative;overflow-x: hidden;" >

    <topnav ref="topnavbox"/>


    <router-view ref="routbox" />


    <botnav />

  </div>
</template>


<script>
  import botnav from './components/comp/botnav'
  import topnav from './components/comp/topnav'

export default {
    components:{
      topnav,
      botnav,
    },
  name: 'App',
  data(){
    return{
      pagedata:{},
    }
  },

  mounted() {
      window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
  },
  methods:{

    handleScroll(e) {

      // 在这里添加你的滚动处理逻辑
      //var juli = window.screenTop;
      //console.log('页面正在滚动'+juli,e);
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      //console.log('当前滚动位置:', scrollPosition);
      if(scrollPosition>40){
        this.$nextTick(()=>{
          this.$refs.topnavbox.set_bgW(true);
        });
      }else{
        this.$nextTick(()=>{
          this.$refs.topnavbox.set_bgW(false);
        });
      }
    }
  },

  created() {

      /*
    this.pagedata={
      'appname':'Go有库',
      'appsm':'Go有库,是舒玉信息的综合型门户站点。在这里,我们展示公司动态,产品及各类系统等服务。让大家更多的了解我们。 每次的回眸微笑将是引领我们前行的那一缕阳光。',
      'bottxt':'每次的回眸微笑将是引领我们前行的那一缕阳光',
      'copyrigth':'舒玉信息技术有限公司保留所有权利',
      'beianhao':'苏ICP备19006471号-2',
      'gongwangcode':'32061202001335',
      'gongwangtxtinfo':'苏公网安备32061202001335',
    }

    var topnavinfo={
      'logoimg':'../../../static/ykico7.png',
      'showname':false,
      'navlist':null,
      'rightnav':null,
    }
    var topnavlist=[];
    topnavlist[0]={
      'name':'Go有库[舒玉信息]',
      'keyname':'home',
      'ischeck':true,
      'type':'rout',
      'url':'',
      'varname':'id', //是rout的时候用
      'valval':'',//rout 对应的信息
      'target':'',
      child:null,
    }
    topnavlist[1]={
      'name':'有库旅居PMS',
      'keyname':'',
      'ischeck':null,
      'type':'link',
      'url':'https://pms.goyoku.com',
      'target':'_blank',
      child:null,
    }
    topnavlist[2]={
      'name':'有库公众号',
      'keyname':'',
      'ischeck':null,
      'type':'imgcode',
      'imgurl':'',
      'url':'https://pms.goyoku.com',
      'target':'_blank',
      child:null,
    }
    topnavinfo.navlist=topnavlist;


   var botnavlist=[];
    //botnavlist[0]={}; botnavlist[1]={}; botnavlist[2]={};
    //txt link rout
    botnavlist[0]={
      'name':'导航链接',
      'type':'txt',
      'url':'',
      'target':'_blank',
      'child':[
        {
          'name':'有库旅居PMS',
          'type':'link',
          'url':'https://pms.goyoku.com',
          'target':'_blank',
          'child':null,
        },
        {
          'name':'有库云盘',
          'type':'link',
          'url':'https://pan.goyoku.com',
          'target':'_blank',
          'child':null,
        },
        {
          'name':'有库发布',
          'type':'link',
          'url':'http://bbs.goyoku.com',
          'target':'_blank',
          'child':null,
        },
        {
          'name':'有库国际',
          'type':'link',
          'url':'http://jpshare.goyoku.com',
          'target':'_blank',
          'child':null,
        },

      ],
    }
    botnavlist[1]={
      'name':'有库用户',
      'type':'txt',
      'url':'',
      'target':'',
      'child':[
        {
          'name':'用户中心',
          'type':'link',
          'url':'https://ucenter.goyoku.com',
          'target':'_blank',
          'child':null,
        },
        {
          'name':'有库搜索',
          'type':'link',
          'url':'http://search.goyoku.com',
          'target':'_blank',
          'child':null,
        },
        {
          'name':'注册有库账户',
          'type':'link',
          'url':'http://passport.goyoku.com/?Rturl=https://www.goyoku.com',
          'target':'_blank',
          'child':null,
        },
        {
          'name':'账户隐私保护',
          'type':'link',
          'url':'http://bbs.goyoku.com',
          'target':'_blank',
          'child':null,
        },
      ]
    }
    botnavlist[2]={
      'name':'有库商城',
      'type':'txt',
      'url':'',
      'target':'_blank',
      'child':null
    }

    this.pagedata.topnavinfo=topnavinfo;
    this.pagedata.botnavlist=botnavlist;

    var hmpg={};
    hmpg[0]={
      'jiange':'20px',
      'layout':{
        'width':'100%',
        'height':'600px',
        'margin':'0 auto',
        'maxWidth':'1920px',
        'display':'',
        backgroundColor: '#ffffff',
        justifyContent:'',
        alignItems:'',
        overflow:'',
      },
      'type':'bann1',
      'imglist':[
        {
          'slidecss':{
            width: '100%',
            height:'600px',
            backgroundColor: '#ffffff',
            maxWidth:'1920px',
            margin:'0 auto',
          },
          'img':'https://pan.goyoku.com/pan/fmshow/showimg_runn_file/2511052780881793011762327808.png',
          'type':'link',
          'url':'https://pms.goyoku.com',
          'valval':'123223',
          'target':'_blank',
        },

        {
          'slidecss':{
            width: '100%',
            height:'600px',
            backgroundColor: '#ffffff',
            maxWidth:'1920px',
            margin:'0 auto',
          },
          'img':'https://pan.goyoku.com/pan/fmshow/showimg_runn_file/2511052898880632011762328988.jpg',
          'type':'txt',
          'url':'http://www.baidu.com',
          'valval':'',
          'target':'_blank',

        },

      ]
    }

    hmpg[1]={
      'jiange':'20px',
      'layout':{
        'width':'100%',
        'height':'auto',
        'margin':'0 auto',
        'maxWidth':'1140px',
        'display':'flex',
        backgroundColor: '#ffffff',
        justifyContent:'space-between',
        alignItems:'flex-start',
        overflow:'',
      },
      'type':'infoboxL',//infoboxL 和infoboxR

      'cont':{
        'imglayout':{
          width:'400px',
          flexShrink:0,
        },
        'titnamelayout':{textAlign:'left', fontSize:'clamp(3rem, 0.373rem + 5vw, 3.5rem)',color:'#414141',},
        'titsmlayout':{textAlign:'left', fontSize:'clamp(.8rem, 0.373rem + 3vw, 1.3rem)',color:'#616161',},
        'titname':'关于有库。',
        'titsm':'Go有库是舒玉信息的系列产品集合,提供专业酒店管理系统及各类解决方案,同时结合软硬件定向开发,实现高效的管理和价值。同时通过定制化标准化的流程管理,实现公司业务的拓展延伸。',
        'imgurl':'https://admob.google.cn/home/static/images/cn/homepage-hero.jpg',
        'tyle':'txt',
        'url':'',
        'valval':'123223',
        'target':'_blank',

      }

    }

    hmpg[2]={
      'jiange':'20px',
      'layout':{
        'width':'100%',
        'height':'auto',
        'margin':'0 auto',
        'maxWidth':'1140px',
        'display':'flex',
        backgroundColor: '#ffffff',
        justifyContent:'space-between',
        alignItems:'flex-start',
        overflow:'',
      },
      'type':'newsboxlist',
      'ggbox':[
        {
          'layout':{
            'width':'30%',
            'backgroundColor':'#0052d9',
          },
          'contlayout':{
            color:'#ffffff',
            padding: '24px',
            width: '100%',
            height: '300px',
          },

          'showtm':'2025-10-12',
          'imgurl':'https://www.goyoku.com/static/img/pan.bb3b842.png',
          'titna':'有库云盘',
          'titsm':'轻便型私有云盘,数据文件的管理中心',

          'type':'link',
          'url':'https://pan.goyoku.com',
          'valval':'123223',
          'target':'_blank',

        },
        {
          'layout':{
            'width':'30%',
            'backgroundColor':'#519456',
          },
          'contlayout':{
            color:'#ffffff',
            padding: '24px',
            width: '100%',
            height: '300px',
          },

          'showtm':'2025-08-12',
          'imgurl':'https://www.goyoku.com/static/img/bbs.26c07d4.png',
          'titna':'有库BBS',
          'titsm':'小小论坛,大家的聊天小天地',

          'type':'link',
          'url':'http://bbs.goyoku.com',
          'valval':'123223',
          'target':'_blank',

        },
        {
          'layout':{
            'width':'30%',
            'backgroundColor':'#9c27b0',
          },
          'contlayout':{
            color:'#ffffff',
            padding: '24px',
            width: '100%',
            height: '300px',
          },

          'showtm':'2025-01-12',
          'imgurl':'https://www.goyoku.com/static/img/erp1.2226610.png',
          'titna':'有库仓储ERP',
          'titsm':'仓储ERP,基本的进销存,单确实整个业务逻辑中不可或缺的一环',

          'type':'link',
          'url':'http://www.baidu.com',
          'valval':'123223',
          'target':'_blank',

        }
      ],


    }
    hmpg[3]={
      'jiange':'20px',
      'layout':{
        'width':'100%',
        'height':'auto',
        'margin':'0 auto',
        //'maxWidth':'1140px',
        'display':'block',
        backgroundColor: '#ffffff',
        justifyContent:'',
        alignItems:'',
        overflow:'',
      },
      'type':'infoboxC',//infoboxL 和infoboxR

      'cont':{
        'titnamelayout':{fontSize:'3rem', width:'100%', textAlign:'center'},
        'titsmlayout':{fontSize:'1.3rem',width:'100%', textAlign:'center',color:"#575757"},
        'imglayout':{width:'100%',height:'430px',overflow:'hidden',},
        'titname':'让应用系统成为企业助手。',
        'titsm':'多年的技术开发积累,实现业务层逻辑层管理层的相互融合,通过系统服务提高企业高效稳定的管理',
        'imgurl':'https://pan.goyoku.com/pan/fmshow/showimg_runn_file/2511068899954983011762388999.png',
        'type':'link',
        'url':'http://www.baidu.com',
        'valval':'123223',
        'target':'_blank',

      }

    }

    hmpg[4]={
      'jiange':'20px',
      'layout':{
        'width':'100%',
        'height':'auto',
        'margin':'0 auto',
        'maxWidth':'1140px',
        'display':'flex',
        backgroundColor: '#ffffff',
        justifyContent:'space-between',
        alignItems:'flex-start',
        overflow:'',
      },
      'type':'newsboxlist',
      'ggbox':[
        {
          'layout':{
            'width':'66%',
            'backgroundColor':'#a61043',
          },
          'contlayout':{
            color:'#ffffff',
            padding: '24px',
            width: '100%',
            height: '300px',
          },

          'showtm':'',
          'imgurl':'https://pan.goyoku.com/pan/fmshow/showimg_runn_file/2511052239608435011762322396.jpg',
          'titna':'我们不断前行,不停探索',
          'titsm':'面向多元化与快节奏,舒玉信息放慢脚步,追求更深层次的探索<br />做好做精<br />也欢迎您的加入',

          'type':'txt',
          'url':'http://www.baidu.com',
          'valval':'123223',
          'target':'_blank',

        },
        {
          'layout':{
            'width':'33%',
            'backgroundColor':'#fff',
          },
          'contlayout':{
            color:'#0052d9',
            padding: '24px',
            width: '100%',
            height: '300px',
          },

          'showtm':'',
          'imgurl':'https://5b0988e595225.cdn.sohucs.com/images/20180726/0e8d5ec4517145c18b71d7918ee0b64a.jpeg',
          'titna':'舒玉招聘',
          'titsm':'因业务发展需要,我们将在有库BBS上发布招聘与合作信息',

          'type':'link',
          'url':'http://bbs.goyoku.com',
          'valval':'123223',
          'target':'_blank',

        },

      ],


    }

    hmpg[5]={
      'jiange':'20px',
      'layout':{
        'width':'100%',
        'height':'auto',
        'margin':'0 auto',
        'maxWidth':'1140px',
        'display':'flex',
        backgroundColor: '#ffffff',
        justifyContent:'space-between',
        alignItems:'center',
        overflow:'',
      },
      'type':'infoboxR',//infoboxL 和infoboxR

      'cont':{
        'imglayout':{
          width:'200px',
          flexShrink:0,
        },
        'titnamelayout':{textAlign:'right', fontSize:'clamp(3rem, 0.373rem + 5vw, 2rem)',color:'#414141',},
        'titsmlayout':{textAlign:'right', fontSize:'clamp(.8rem, 0.373rem + 3vw, 1rem)',color:'#414141',},
        'titname':'联系我们。',
        'titsm':'<div style="text-align: right;">扫码关注公众号,了解我们的前端业务<br />' +
                '<a style="cursor: pointer;color: #2a4ee4;">直接和我们联系</a>' +
                '</div>',
        'imgurl':'https://pan.goyoku.com/pan/fmshow/showimg_runn_file/2111226469995249011637564699.jpg',
        'tyle':'txt',
        'url':'',
        'valval':'123223',
        'target':'_blank',

      }

    }


    this.pagedata.hmpg=hmpg;



       */



    //console.log(JSON.stringify(this.pagedata));


  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue